const {
  offerDates,
  offerTimes,
  offerLayout,
  offerPrice,
  offerEvent,
  offerCapacity,
} = require("./offerParsers");
const getPreviousOffer = ({ message, messages, currency }) => {
  let idx = messages.indexOf(message);
  while (idx > 0) {
    idx--;
    if (messages[idx] && messages[idx].offer && messages[idx].offer.dates)
      return messages[idx].offer;
  }
  return null;
};
const diffChecker = {
  first_deposit_amount: ({ current, previous }) => {
    return (
      current.first_deposit_amount !== previous.first_deposit_amount ||
      current.first_deposit_online !== previous.first_deposit_online
    );
  },
  dates: ({ current, previous }) => {
    return (
      current.dates
        .replace(/^0/g, "")
        .replace(/ 0/g, " ")
        .replace(/\/0/g, "/") !==
      previous.dates.replace(/^0/g, "").replace(/ 0/g, " ").replace(/\/0/g, "/")
    );
  },
};
const offerDetails = {
  capacity: ({ current, previous }) => {
    return {
      title: "Guests",
      value: [
        offerCapacity(previous.capacity),
        offerCapacity(current.capacity),
      ],
    };
  },
  cost: ({ current, previous, currency }) => {
    return {
      title: "Price",
      value: [
        `${currency.symbol || currency}${offerPrice(previous.cost)}`,
        `${currency.symbol || currency}${offerPrice(current.cost)}`,
      ],
    };
  },
  layout: ({ current, previous }) => {
    return {
      title: "Layout",
      value: [offerLayout(previous.layout), offerLayout(current.layout)],
    };
  },
  dates: ({ current, previous }) => {
    return {
      title: "Dates",
      value: [offerDates(previous), offerDates(current)],
    };
  },
  hours: ({ current, previous }) => {
    return {
      title: "Hours",
      value: [offerTimes(previous), offerTimes(current)],
    };
  },
  first_deposit_amount: ({ current, previous, currency }) => {
    const showOnline =
      current.first_deposit_online !== previous.first_deposit_online;
    return {
      title: "Deposit",
      value: [
        `${currency.symbol || currency}${offerPrice(
          previous.first_deposit_amount
        )}`,
        `${currency.symbol || currency}${offerPrice(
          current.first_deposit_amount
        )}${
          showOnline
            ? current.first_deposit_online
              ? " online"
              : " offline"
            : ""
        }`,
      ],
    };
  },
  event_type: ({ current, previous }) => {
    return {
      title: "Event Type",
      value: [offerEvent(previous.event_type), offerEvent(current.event_type)],
    };
  },
};
const compareOffers = ({
  current,
  previous,
  currency,
  changeSeparator = "⇢",
  fromWrapper = (from) => from,
  toWrapper = (to) => to,
}) => {
  const changed = {};
  Object.keys(offerDetails).forEach((k) => {
    if (
      diffChecker[k]
        ? diffChecker[k]({ current, previous })
        : current[k] !== previous[k]
    ) {
      const { title, value } = offerDetails[k]({
        current,
        previous,
        currency,
        changeSeparator,
      });
      const [from, to] = value;
      changed[k] = {
        title,
        value: `${fromWrapper(from)} ${changeSeparator} ${toWrapper(to)}`,
        from,
        to,
      };
    }
  });
  return changed;
};
const offerChanges = ({
  message,
  thread,
  currency,
  changeSeparator = "⇢",
  fromWrapper = (from) => from,
  toWrapper = (to) => to,
}) => {
  const { messages } = thread;
  if (!message.offer || !message.offer.dates)
    throw new Error("Message does not contain an offer");
  const { offer } = message;
  // console.log({ offer })
  const previousOffer = getPreviousOffer({ message, messages });
  if (!previousOffer) return null;
  return compareOffers({
    current: { ...offer },
    previous: { ...previousOffer },
    currency,
    changeSeparator,
    fromWrapper,
    toWrapper,
  });
};

module.exports = {
  offerChanges,
};
